<script>
  import { HIDE_HOVER_TEXT, CHAT_TITLE } from '../js/l10n/en_US.js';

  import { CHAT_COLLAPSE_SIZE, CHAT_GENERAL_CHANNEL_NAME } from '../js/constants.js';

  import { accessState, chatState, roomsState, streamState } from '../js/state.js';

  import Chat from './Chat.svelte';
  import Bowser from 'bowser';
  let bowser = Bowser.parse(window.navigator.userAgent);
  const isSafari = bowser.browser.name === 'Safari';
  const tabIcons = {
    merch: 'icon-shopping_cart',
    donate: 'icon-card_giftcard',
  };
  let activeClass = 'active';

  export let source = '',
    id = '',
    chatEnabled = false,
    embeddedPagesEnabled = false,
    embeddedPages = [],
    toggleTabsVisible = () => {};

  let LIVE_CHAT_TAB = 'live_chat',
    activeTab = LIVE_CHAT_TAB;

  $: if (!chatEnabled) {
    activeTab = 0;
  }

  // Only show active tab class if there is only one tab
  $: if (chatEnabled) {
    if (!embeddedPagesEnabled) {
      activeClass = '';
    } else if (!embeddedPages || embeddedPages.length == 0) {
      activeClass = '';
    } else {
      activeClass = 'active';
    }
  }

  // Only show active tab class if there is only one tab
  $: if (embeddedPagesEnabled) {
    if (!embeddedPages || embeddedPages.length == 0) {
      activeClass = '';
    } else if (embeddedPages.length == 1 && !chatEnabled) {
      activeClass = '';
    } else {
      activeClass = 'active';
    }
  }

  $: if (embeddedPages == null) {
    embeddedPages = [];
  }

  function setActiveTab(newActiveTab) {
    if (!isSafari) {
      activeTab = newActiveTab;
    }
  }

  $: if (embeddedPages == null) {
    embeddedPages = [];
  }
</script>

<div class="tabbable-components-wrap">
  <div class="tabs-header-area">
    <div class="tabs-wrap">
      {#if chatEnabled}
        <div
          class="tab {activeTab == LIVE_CHAT_TAB ? activeClass : ''}"
          on:click={() => {
            setActiveTab(LIVE_CHAT_TAB);
          }}
        >
          <span class="title">
            <i class="icon-chat_bubble_outline" />
            <span>{CHAT_TITLE}</span>
          </span>
        </div>
      {/if}
      {#if embeddedPagesEnabled && Array.isArray(embeddedPages)}
        {#each embeddedPages as tabInfo, i}
          <a
            class="tab {activeTab == i ? activeClass : ''}"
            on:click={() => {
              setActiveTab(i);
            }}
            href={isSafari ? tabInfo.url : undefined}
            target="_blank"
          >
            <span class="title">
              <i class={tabIcons[tabInfo.type]} />
              <span>{tabInfo.title}</span>
            </span>
          </a>
        {/each}
      {/if}
    </div>
    {#if window.innerWidth > CHAT_COLLAPSE_SIZE}
      <i
        class="icon-keyboard_tab"
        on:click={() => {
          toggleTabsVisible();
        }}
      >
        <span class="hover-text">{HIDE_HOVER_TEXT}</span>
      </i>
    {/if}
  </div>
  {#if activeTab == LIVE_CHAT_TAB && chatEnabled}
    <Chat
      {source}
      {id}
      showMessageField={$streamState.use_chat}
      showReactions={$streamState.use_reactions}
      room={$roomsState.current ? $roomsState.current.room_id : CHAT_GENERAL_CHANNEL_NAME}
      sub={$accessState.sub}
      token={$accessState.token}
    />
  {:else if embeddedPages[activeTab]}
    <div class="tab-content">
      <iframe src={embeddedPages[activeTab].url} title={embeddedPages[activeTab].tile} />
    </div>
  {/if}
</div>
